import { render, staticRenderFns } from "./Lista-saldo-proveedores.vue?vue&type=template&id=6b1748fe&scoped=true"
import script from "./Lista-saldo-proveedores.vue?vue&type=script&lang=js"
export * from "./Lista-saldo-proveedores.vue?vue&type=script&lang=js"
import style0 from "./Lista-saldo-proveedores.vue?vue&type=style&index=0&id=6b1748fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1748fe",
  null
  
)

export default component.exports